<template>
    <svg viewBox="0 0 754 547" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
        <path
            d="M107.901 -265.139C150.021 -313.722 201.91 -289.755 235.434 -263.102L393.793 -137.215L552.152 -11.3268C585.677 15.3257 622.041 57.1918 577.704 108.33C533.36 159.469 483.695 132.946 450.171 106.293L291.812 -19.5943L133.453 -145.482C99.9209 -172.134 65.7733 -216.554 107.901 -265.139Z"
            fill="#FF7370"
        />
        <path
            d="M333.442 -375.161C401.329 -411.729 447.838 -363.854 472.954 -320.544L591.586 -115.953L710.219 88.6377C735.335 131.948 756.836 193.299 685.384 231.788C613.925 270.284 570.981 220.482 545.872 177.171L427.239 -27.4196L308.607 -232.01C283.491 -275.321 265.554 -338.592 333.442 -375.161Z"
            fill="#FF91F0"
        />
        <path
            d="M608.347 -375.882C692.369 -390.203 722.553 -324.205 732.284 -270.414L778.259 -16.3331L824.234 237.748C833.965 291.539 833.189 362.819 744.746 377.887C656.311 392.962 630.548 326.202 620.817 272.419L574.834 18.338L528.859 -235.743C519.128 -289.526 524.325 -361.561 608.347 -375.882Z"
            fill="#FF5C57"
        />
    </svg>
</template>
